import type { TaxRate } from '@modules-deprecated/app/taxrates/types'

/**
 * Pass the rates including deactivated ones, so a rate the extraction proposed before it was
 * deactivated still resolves. `null` when there is no rate, the organization does not have it,
 * or it is not a sales rate.
 */
export const getImportedInvoiceVatRate = (taxRates: TaxRate[] | undefined, vatRateId: string | null): number | null =>
  taxRates?.find((taxRate) => taxRate.id === vatRateId && taxRate.appliesToSales)?.rate ?? null
